import React from "react";
import { Facebook, Instagram, Email, Phone } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import "./Footer.css"; // Make sure to create this CSS file

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        <p
          style={{
            margin: 0,
            padding: 0,
          }}
        >
          <p
            style={{
              alignSelf: "center",
              margin: 0,
              padding: 2,
            }}
          >
            <p
              style={{
                margin: 0,
                padding: 0,
                fontSize: "1.7rem",
              }}
              className="logoContact2"
            >
              Sharron Aubrey
            </p>
            <p
              style={{
                margin: 0,
                padding: 0,
              }}
              className="logoContact2"
            >
              English Productions
            </p>
            <p
              style={{
                margin: 0,
                padding: 0,
                fontSize: 10,
              }}
            >
              © Copyrights 2024 all rights reserved
            </p>
            {/* <p style={{}} className="logoContact">
              
            </p> */}
          </p>
        </p>
      </div>
      {/* <div className="footer-right">
        <IconButton
          href="https://www.facebook.com/p/English-Productions-100063923112908/"
          target="_blank"
          aria-label="Facebook"
        >
          <Facebook style={{ color: "#4267B2" }} />
        </IconButton>
        <IconButton
          href="https://www.instagram.com/english_productions_"
          target="_blank"
          aria-label="Instagram"
        >
          <Instagram style={{ color: "#C13584" }} />
        </IconButton>
        <IconButton
          href="mailto:englishproductions@hotmail.com"
          aria-label="Email"
        >
          <Email style={{ color: "#D44638" }} />
        </IconButton>
        <IconButton href="tel:0265831614" aria-label="Phone">
          <Phone style={{ color: "#34b7f1" }} />
        </IconButton>
      </div> */}
    </footer>
  );
};

export default Footer;
